// 下面两个package要单独安装
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  install (Vue, options) {
    /**
     * @params pdfHeight: 页面高度，建议按纸张(A3,A4,A5)比例填写。
     * A4纸尺寸: [595.28, 841.89]
     * 现修改为，多页时每页高度为pdfHeight，而不是固定的A4高度841.89
     * TODO: 1.纸张方向/边距以参数传入; 2.优化宽高计算逻辑
     * */
    Vue.prototype.getPdf = function (id, title, pdfHeight = 595) {
      html2Canvas(document.querySelector(`#${id}`), {
        // allowTaint: true
        useCORS: true // 看情况选用上面还是下面的，
      }).then(function (canvas) {
        console.log({canvas: canvas})
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = contentWidth / 592.28 * 841.89
        // let pageHeight = contentWidth / 690 * 975.85
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = 592.28 / contentWidth * contentHeight
        // let imgWidth = 690
        // let imgHeight = 690 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('l', 'pt', [695, pdfHeight])
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 50, 20, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 50, position, imgWidth, imgHeight)
            leftHeight -= pdfHeight
            position -= pdfHeight
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/htmltopdf.js